import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var KeyboardDoubleArrowRight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
  }));
});
KeyboardDoubleArrowRight.displayName = 'KeyboardDoubleArrowRight';
export var KeyboardDoubleArrowRightDimensions = {
  height: 24,
  width: 24
};